import { BETAS } from '@/settings/subscription-settings/betas/betas.config';

export { BETA_OPT_INS_SETTING, toBetaOptIns, toVisibleToUsersFlags } from '@pendo/middleware';

export const BETA_BY_ID = BETAS.reduce((accumulator, beta) => {
    accumulator[beta.id] = beta;

    return accumulator;
}, {});
